/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   mat-card[_ngcontent-%COMP%]{margin-left:40px;margin-right:40px;margin-bottom:20px}"];
export { styles as styles };
